<template>
    <div class="mainmobile modulewrap " v-title data-title="英国名校本硕连读项目">
        <div class="zxlist" v-for="(item,index) in infodata" :key="item.id">

            <div v-if="index>0" class="signform">
                <dl>
                    <dt>姓名</dt>
                    <dd>
                        <el-input type="text" v-model="infosign.signname" placeholder="请输入您的姓名" maxlength="50">

                            <span class="msg" v-if="!infosign.signname && iserrname" slot="suffix">请输入</span>
                        </el-input>
                    </dd>
                </dl>
                <dl>
                    <dt>手机号</dt>
                    <dd>
                        <el-input type="text" v-model="infosign.mobile" placeholder="请输入您的手机号" @change="valimobile" maxlength="50">
                            <span class="msg" v-if="infosign.mobile=='' && errmobile==1" slot="suffix">请输入</span>
                            <span class="msg" v-if="errmobile==2" slot="suffix">请输入正确的手机号</span>
                        </el-input>
                    </dd>
                </dl>

                <div class="signbtn"><a href="#" @click="sign">立即预约咨询</a></div>
            </div>

            <div class="content editor">
                <span v-html="item.content"></span>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: 'sign',
        data() {
            return {
                res: {},
                infodata: {},
                infosign: {
                    signname: '',
                    mobile: ''
                },
                iserrname: false,
                errmobile: 0
            };
        },
        methods: {

            getdata: function () {
                let id = this.$common.basic.chstr2int(this.$route.params.id);
                let act = id == 0 ? 'zx_sign_info' : id == 1 ? 'zx_sign_info2' : 'zx_sign_info3';
                this.$common.fetch({ 'act': act }, res => {
                    this.infodata = res.infodata;
                });
            },
            sign: function () {
                let iserr = false;
                if (!this.infosign.signname) {
                    this.iserrname = true;
                    iserr = true;
                }
                else {
                    this.iserrname = false;
                }
                this.valimobile();
                if (this.errmobile > 0) {
                    iserr = true;
                }
                if (!iserr) {
                    let jsondata = {
                        'postdata': {
                            'act': 'zx_sign', "data": this.infosign
                        }, 'msg': '正在提交...'
                    };
                    this.$common.post(jsondata, (res) => {
                        this.$common.success(res.msg);
                    });
                }

            },
            valimobile: function () {
                if (!this.infosign.mobile) {
                    this.errmobile = 1;
                }
                else {
                    let ismobile = this.$common.validate(this.infosign.mobile, "ismobile") == 1;
                    this.errmobile = ismobile ? 0 : 2;
                }

            }
        },
        mounted() {

            this.getdata();

        }
    }
</script>
<style>
    .zxlist { width: 100%; flex-flow: column nowrap }
        .zxlist .editor { padding: 0 !important }
    .sslist .content img { width: 100%; }
    .signform { width: 100%; padding-left: 30px; padding-right: 30px; flex-flow: column nowrap; margin-top: 10px; margin-bottom: 10px; }
        .signform dl { width: 100%; flex-flow: column nowrap; }
            .signform dl dt { font-size: 1em; color: #1a1a1a; padding-bottom: 10px; }
            .signform dl dd { padding-bottom: 10px; }
                .signform dl dd .el-input__inner { border: 1px solid #e6322e; border-radius: 6px; overflow: hidden }
        .signform .msg { display: flex; align-items: center; height: 100%; padding-right: 20px; color: #e6322e }
        .signform .signbtn { width: 100%; margin-top: 10px; }
            .signform .signbtn a { display: block; width: 100%; height: 40px; line-height: 40px; line-height: 40px; background-color: #e6322e; color: #FFF; text-align: center; border-radius: 20px; }
</style>
